import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCovidHead = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.7718 21.375V18.05H17.0743C17.2199 18.0501 17.364 18.0215 17.4985 17.9659C17.6331 17.9102 17.7553 17.8286 17.8582 17.7256C17.9612 17.6227 18.0428 17.5005 18.0985 17.3659C18.1541 17.2314 18.1827 17.0872 18.1826 16.9417V14.5525H19.4626C19.6048 14.5526 19.7447 14.517 19.8696 14.4492C19.9945 14.3813 20.1004 14.2832 20.1777 14.1639C20.255 14.0446 20.3012 13.9079 20.3121 13.7662C20.323 13.6244 20.2982 13.4822 20.2401 13.3525C19.4026 11.4883 18.1793 9.19667 18.1793 9.19667V7.38083C18.1801 7.13684 18.1284 6.89553 18.0276 6.67333C17.6896 5.75807 17.1364 4.93754 16.4147 4.28096C15.693 3.62438 14.824 3.15103 13.8809 2.90083C8.89927 1.59417 3.72261 5.08333 3.68511 10.23C3.6756 11.3198 3.89891 12.399 4.34011 13.3955C4.78131 14.392 5.43022 15.2828 6.24344 16.0083V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.84009 10.0825C8.84009 10.696 9.08381 11.2844 9.51765 11.7183C9.95148 12.1521 10.5399 12.3958 11.1534 12.3958C11.767 12.3958 12.3554 12.1521 12.7892 11.7183C13.223 11.2844 13.4668 10.696 13.4668 10.0825C13.4668 9.46896 13.223 8.88056 12.7892 8.44672C12.3554 8.01289 11.767 7.76917 11.1534 7.76917C10.5399 7.76917 9.95148 8.01289 9.51765 8.44672C9.08381 8.88056 8.84009 9.46896 8.84009 10.0825V10.0825Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7686 6.03418H11.5394"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1533 6.03418V7.76918"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7434 6.94751L14.2884 7.49251"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.016 7.22L12.7893 8.44667"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2017 9.69666V10.4683"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2018 10.0825H13.4668"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2884 12.6725L13.7434 13.2175"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.016 12.945L12.7893 11.7183"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5394 14.1308H10.7686"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1533 14.1308V12.3958"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.56355 13.2175L8.01855 12.6725"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.29102 12.945L9.51768 11.7183"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.10522 10.4683V9.69666"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.10522 10.0825H8.84022"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.01855 7.49251L8.56355 6.94751"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.29102 7.22L9.51768 8.44667"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCovidHead.displayName = 'SvgCovidHead';
export default SvgCovidHead;
